import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-blue-500 animate-spin" />
            </div>
        );
    }
    if (!user || typeof user !== "object") {
        return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }
    // Trial-expired free users: lock everything except the subscription page so
    // they can still upgrade (or log out via the topbar menu).
    // Gekauftes Bewerbungs-Guthaben (credits) zählt wie bezahlter Zugang.
    if (user.trial_expired && !(user.credits > 0) && loc.pathname !== "/dashboard/abo") {
        return <Navigate to="/dashboard/abo?trial=expired" replace />;
    }
    return children;
}
